module.exports = __webpack_public_path__ + "static/mpost52.a096c704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost52.jpg
// module id = 254
// module chunks = 35783957827783 269829036549620